module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding@2x-0417bf808df8a9b79d8080f18669c80c.webp";